<template>
    <v-flex v-if="isActive" xs12 md4>
        <v-layout row wrap>
            <v-flex md2 hidden-sm-and-down>
                &nbsp;
            </v-flex>
            <v-flex xs12 md10>
                <v-text-field
                    v-model="extensionMetadata"
                    :append-icon="appendIcon"
                    :label="label"
                    :maxlength="maxLength"
                    :outlined="outlined"
                    :rules="[
                        !isRequired || requiredField(),
                        v => (!isNaN(v)) || $t('base.errors.invalidExtension')
                    ]"
                    :data-meta-id="getPhoneExtensionMetadata.id"
                    :name="name"
                    :id="name"
                    @input="emitValue"
                />
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { find, get } from 'lodash';
import { MetadataEnum } from '@/enums';

export default {
    name: 'phone-extension',
    mixins: [formRules],
    props: {
        otherMetadata: { type: Array, required: true },
        outlined: { type: Boolean, required: false, default: true },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            extensionMetadata: '',
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getBaseMetadataById: 'services/getBaseMetadataById',
        }),
        getPhoneExtensionMetadata() {
            return find(this.otherMetadata, ['metadata', MetadataEnum.PHONE_EXTENSION]);
        },
        appendIcon() {
            return this.withIcon ? 'fas fa-phone' : '';
        },
        isRequired() {
            return get(this.getPhoneExtensionMetadata, 'required', 0);
        },
        label() {
            return (this.isRequired ? '* ' : '') +
                this.getBaseMetadataById(MetadataEnum.PHONE_EXTENSION)[`description${this.upperLocale}`];
        },
        name() {
            return this.getBaseMetadataById(MetadataEnum.PHONE_EXTENSION)[`name`];
        },
        maxLength() {
            const metadata = this.getBaseMetadataById(MetadataEnum.PHONE_EXTENSION);
            return metadata && metadata.rules && metadata.rules.maxLength;
        },
        isActive() {
            return get(this.getPhoneExtensionMetadata, 'status', 0) === 1;
        },
    },
    methods: {
        emitValue() {
            this.$emit('updateOtherMetadata', {
                metadata: this.getPhoneExtensionMetadata,
                value: this.extensionMetadata,
            });
        },
    },
};
</script>
